import React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import plLocale from 'date-fns/locale/pl';
import { useSelector } from 'react-redux';

import TopBar from './TopBar';
import { iconAcceptStyles, iconErrorStyles, iconStyles } from './styles';
import {checkTooYoung, getBirthYear} from './utility';
import { addMiliSeconds, checkTooOld } from './utility';

function DatePickerFormField({ value, valid, age, onChange }) {
  const tooOldMsg = useSelector((store) => store.data.formFieldErrors.date);
  const tooYoungMsg = useSelector((store) => store.data.formFieldErrors.dateAgeTooLow);

  let tooOld = false;
  if (value) {
    if (checkTooOld(value)) tooOld = true;
  }

  let tooYoung = false;
  if (value) {
    if (checkTooYoung(value)) tooYoung = true;
  }

  const handleOnChange = (date) => {
    // there is something wrong with timezones, adding hours because we are +2
    const updatedDate = !value ? addMiliSeconds(date, 2 * 3600 * 1000) : date;
    const valid = (checkTooOld(updatedDate) || checkTooYoung(updatedDate)) ? false : true;

    onChange(updatedDate, valid);
  };

  return (
    <div style={{ position: 'relative' }}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={plLocale}>
        <DatePicker
          fullWidth
          orientation="portrait"
          openTo="year"
          views={['year', 'month', 'date']}
          inputVariant="standard"
          maxDate={new Date()}
          value={value || getBirthYear(age)}
          emptyLabel="DD/MM/RRRR"
          format="dd/MM/yyyy"
          invalidDateMessage="Błędna data"
          onChange={handleOnChange}
          error={value ? !valid : false}
          ToolbarComponent={({ openView, date }) => (
            <TopBar status={openView} date={date} />
          )}
          cancelLabel={'Anuluj'}
        />
      </MuiPickersUtilsProvider>
      <DateRangeOutlinedIcon
        style={
          value ? (valid ? iconAcceptStyles : iconErrorStyles) : iconStyles
        }
      />
      {tooOld && (
        <div className="FormField-validateText-container">
          <p className="FormField-validateText">{tooOldMsg}</p>
        </div>
      )}
      {tooYoung && (
        <div className="FormField-validateText-container">
          <p className="FormField-validateText">{tooYoungMsg}</p>
        </div>
      )}
    </div>
  );
}

export default DatePickerFormField;
